
export function getBaseLocation() {

    // Known platform URL prefixes. Must match the BaseUrl values in dbo.Application.
    // Extend this list whenever a new platform is added — otherwise APP_BASE_HREF
    // falls back to '/' and Angular fails to match routes for that platform's URLs
    // (manifests as NG04002 "No route matches" — e.g. R-mode popups blank-page).
    let domains = ['ik', 'ba', 'din-hms', 'ahlsell', 'ur', 'medi3', 'unipro', 'svenn', 'agil', 'salutis'];
    let paths: string[] = location.pathname.split('/').splice(1, 1);
    let basePath: string = (paths && paths[0]);


    if (!location.hostname.match(/[^.\s]+\.kuba\.dev/m) != null) {
        if (domains.indexOf(basePath) > -1) {
            return '/' + basePath;
        }else {
            return '/';
        }
    }else {
        return '/' ;
    }

}

/**
 * URL prefix of the platform the app is currently served under, without a
 * trailing slash: '/agil' on Agil, '/medi3' on Medi3, '' on Kuba's own hosts.
 *
 * Same source of truth as {@link getBaseLocation}, which is what APP_BASE_HREF
 * is built from — so this agrees with the prefix the router already writes into
 * every URL.
 */
export function getPlatformPrefix(): string {
    const base = getBaseLocation();
    return base === '/' ? '' : base;
}

/** True when the app is being served under the Agil platform prefix. */
export function isAgilPlatform(): boolean {
    return getPlatformPrefix() === '/agil';
}

/** MDCO branding belongs to the dinHMS platform. */
export function isDinHmsPlatform(): boolean {
    return getPlatformPrefix() === '/din-hms';
}

/**
 * Absolute path of the login page for the platform the app is served under.
 *
 * Router navigations get the prefix for free from APP_BASE_HREF, but a hard
 * `window.location.href` assignment does not: a bare '/login' drops the prefix
 * and drops an Agil or Medi3 user on Kuba's own login, on a page that neither
 * carries their branding nor leads back to where they were. Use this for every
 * redirect that bypasses the router.
 */
export function getLoginUrl(): string {
    return `${getPlatformPrefix()}/login`;
}
